import { render, staticRenderFns } from "./gnss-carousel.vue?vue&type=template&id=53a4f0fc&scoped=true"
import script from "./gnss-carousel.vue?vue&type=script&lang=js"
export * from "./gnss-carousel.vue?vue&type=script&lang=js"
import style0 from "./gnss-carousel.vue?vue&type=style&index=0&id=53a4f0fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a4f0fc",
  null
  
)

export default component.exports